export const handlePending = (state) => {
    state.isLoading = true
    state.errors = {}
}